import useSWR, { SWRConfiguration } from 'swr'
import { coreApi } from 'services/api'
import { toast } from 'react-toastify'

export function useGetStudentMessage(studentId: string, messageId: string) {
  const url = `/notifications/messages/student/${studentId}/message/${messageId}`

  const key = [url]

  return useSWR(key, fetcher, configuration)
}

const fetcher = ([url]: [string]) => coreApi.get(url).then((res) => res.data)

const configuration: SWRConfiguration = {
  fallbackData: '',
  shouldRetryOnError: true,
  onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
    if (retryCount > 3) {
      toast.error('Não foi possível carregar seus recados. Tente novamente mais tarde.')
    } else {
      setTimeout(() => revalidate({ retryCount }), 1000)
    }
  },
  keepPreviousData: true,
  dedupingInterval: 60e3,
  revalidateOnReconnect: true,
}
